import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-search-item-dropdown",
  "use": "icon-search-item-dropdown-usage",
  "viewBox": "0 0 10 10",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 10 10\" id=\"icon-search-item-dropdown\">\n  <path d=\"M1.91403 3.71426L4.64411 6.9002C4.68811 6.95152 4.7427 6.99272 4.80413 7.02097C4.86555 7.04921 4.93236 7.06384 4.99997 7.06384C5.06758 7.06384 5.13438 7.04921 5.19581 7.02097C5.25723 6.99272 5.31182 6.95152 5.35583 6.9002L8.08591 3.71426C8.34645 3.41016 8.13044 2.94043 7.73005 2.94043H2.26911C1.86872 2.94043 1.6527 3.41016 1.91403 3.71426Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol